<wk-settings-breadcrumb (breadcrumbNavigate)="onBreadcrumbNavigate($event)" />
<div class="col-lg-6 col-md-10 wk-sdm__select">
    <wk-dashboard-select [checkDashboardVisibility]="checkDashboardVisibility" [showAll]="true" (canChangeDashboard)="canChangeDashboard($event)" />
    @if (selectedCount > 0) {
        <button kendoButton class="wk-sdm__select-count" (click)="onUnselectAll()">
            <span>
                {{ selectedCount }}&nbsp;{{
                    (selectedCount === 1 ? "AllView.SingleCardSelectedTitle" : "AllView.MultipleCardSelectedTitle") | translate
                }}<i class="fa fa-times button-inner-icon" aria-hidden="true"></i>
            </span>
        </button>
    }
</div>
<ng-template #template let-anchor>
    <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
<div kendoTooltip showOn="none" [tooltipTemplate]="template" (mouseover)="showTooltip($event)" class="wk-sdm__content">
    <input
        #txtInput
        type="text"
        [(ngModel)]="inputTerm"
        (keydown.escape)="txtInput.blur()"
        [formControl]="term"
        autocomplete="off"
        class="form-control wk-sdm__search"
        placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
    />
    <div class="wk-sdm__wrapper">
        <div #tableContainer class="wk-sdm__container">
            <table class="wk-sdm__table">
                <tr #tableHeader class="wk-sdm__table-header">
                    <th class="wk-sdm__table-header-cell wk-sdm__table-header-cell--select-all">
                        <checkbox-field-pds3>
                            <input type="checkbox" (change)="onSelectAll()" [checked]="selectAll" />
                        </checkbox-field-pds3>
                    </th>
                    <th
                        class="wk-sdm__table-header-cell wk-sdm__table-header-cell--sortable wk-sdm__table-header-cell--first-name"
                        [class.wk-sdm__table-header-cell--sorted]="sortDirAsc !== undefined && sortMember === 'FirstName'"
                    >
                        <button (click)="onSortChange('FirstName')" type="button">
                            @if (sortDirAsc !== undefined && sortMember === "FirstName") {
                                <i class="fa" [class.fa-caret-up]="sortDirAsc" [class.fa-caret-down]="!sortDirAsc"></i>
                            }
                            <span>{{ "Settings.FirstName" | translate }}</span>
                        </button>
                    </th>
                    <th
                        class="wk-sdm__table-header-cell wk-sdm__table-header-cell--sortable wk-sdm__table-header-cell--last-name"
                        [class.wk-sdm__table-header-cell--sorted]="sortDirAsc !== undefined && sortMember === 'LastName'"
                    >
                        <button (click)="onSortChange('LastName')" type="button">
                            @if (sortDirAsc !== undefined && sortMember === "LastName") {
                                <i class="fa" [class.fa-caret-up]="sortDirAsc" [class.fa-caret-down]="!sortDirAsc"></i>
                            }
                            <span>{{ "Settings.LastName" | translate }}</span>
                        </button>
                    </th>
                    @if (group1Enabled && getGroup1UsersEnabled() == true) {
                        <th class="wk-sdm__table-header-cell wk-sdm__table-header-cell--group1">
                            <!------------------------------------------------------------------->
                            <!-- Need to be moved to the component + Replaced by the component -->
                            <div class="wk-cf">
                                <div
                                    class="wk-cf__container"
                                    kendoPopoverContainer
                                    filter=".wk-cf__trigger--group1"
                                    #group1PopoverTrigger="kendoPopoverContainer"
                                >
                                    <div>{{ getGroup1Caption() }}</div>
                                    <button
                                        class="wk-cf__trigger wk-cf__trigger--group1"
                                        [class.wk-cf__trigger--funnel-filled]="group1Options && group1Options.selectedValues.length > 0"
                                        [class.wk-cf__trigger--funnel]="!group1Options || group1Options.selectedValues.length == 0"
                                        kendoButton
                                    ></button>
                                </div>
                                <kendo-popover #Group1Popover position="bottom" (shown)="onShow()">
                                    <ng-template kendoPopoverBodyTemplate>
                                        <div class="wk-cf__popover">
                                            <div class="wk-cf__popover__header">
                                                <div class="wk-cf__popover__actions">
                                                    <div
                                                        class="wk-cf__popover__actions-link wk-cf__popover__actions-select-all"
                                                        (click)="onSelectAllGroups('group1')"
                                                    >
                                                        {{ "Settings.SelectAll" | translate }}
                                                    </div>
                                                    <div class="wk-rolesOptions-selection-count">
                                                        ( {{ group1Options.selectedValues.length }}
                                                        {{
                                                            (this.group1Options.selectedValues.length > 1
                                                                ? "AllView.MultipleCardSelectedTitle"
                                                                : "AllView.SingleCardSelectedTitle"
                                                            ) | translate
                                                        }}
                                                        )
                                                    </div>
                                                    <div
                                                        class="wk-cf__popover__actions-link wk-cf__popover__actions-selection-clear"
                                                        (click)="onClearAllGroups('group1')"
                                                    >
                                                        {{ "FiltersSidebar.Options.MultiSelect.ClearTitle" | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                            <kendo-textbox
                                                class="wk-cf__popover__search"
                                                placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
                                                (valueChange)="onSearchChange($event, 'group1')"
                                            >
                                                <button kendoButton fillMode="flat"></button>
                                            </kendo-textbox>
                                            <div class="wk-cf__popover__list">
                                                @for (item of settingPagedItems; track item.id) {
                                                    <checkbox-field-pds3
                                                        size="extra-small"
                                                        labelFor="group1-{{ item.id }}"
                                                        [label]="item.value | wkTranslate"
                                                    >
                                                        <input
                                                            (change)="onGroup1FilterChange(item)"
                                                            type="checkbox"
                                                            [checked]="isGroupItemSelected(item.id, group1Options)"
                                                            attr.id="group1-{{ item.id }}"
                                                        />
                                                    </checkbox-field-pds3>
                                                }
                                            </div>
                                            @if (maxSettingPageSize > 1) {
                                                <wk-pagination-component
                                                    #pagination
                                                    [collectionSize]="totalItemsCount"
                                                    [pageSize]="settingPageSize"
                                                    [firstLastButtons]="false"
                                                    [currentPage]="settingPageNumber"
                                                    (pageChange)="onSettingPageChange($event, 'group1')"
                                                />
                                            }
                                        </div>
                                    </ng-template>
                                </kendo-popover>
                            </div>
                            <!------------------------------------------------------------------->
                        </th>
                    }
                    @if (group2Enabled && getGroup2UsersEnabled() == true) {
                        <th class="wk-sdm__table-header-cell wk-sdm__table-header-cell--group2">
                            <!------------------------------------------------------------------->
                            <!-- Need to be moved to the component + Replaced by the component -->
                            <div class="wk-cf">
                                <div
                                    class="wk-cf__container"
                                    kendoPopoverContainer
                                    filter=".wk-cf__trigger--group2"
                                    #group2PopoverTrigger="kendoPopoverContainer"
                                >
                                    <div>{{ getGroup2Caption() }}</div>
                                    <button
                                        class="wk-cf__trigger wk-cf__trigger--group2"
                                        [class.wk-cf__trigger--funnel-filled]="group2Options && group2Options.selectedValues.length > 0"
                                        [class.wk-cf__trigger--funnel]="!group2Options || group2Options.selectedValues.length == 0"
                                        kendoButton
                                    ></button>
                                </div>
                                <kendo-popover #Group2Popover position="bottom" (shown)="onShow_Group2()">
                                    <ng-template kendoPopoverBodyTemplate>
                                        <div class="wk-cf__popover">
                                            <div class="wk-cf__popover__header">
                                                <div class="wk-cf__popover__actions">
                                                    <div
                                                        class="wk-cf__popover__actions-link wk-cf__popover__actions-select-all"
                                                        (click)="onSelectAllGroups('group2')"
                                                    >
                                                        {{ "Settings.SelectAll" | translate }}
                                                    </div>
                                                    <div class="wk-rolesOptions-selection-count">
                                                        ( {{ group2Options.selectedValues.length }}
                                                        {{
                                                            (this.group2Options.selectedValues.length > 1
                                                                ? "AllView.MultipleCardSelectedTitle"
                                                                : "AllView.SingleCardSelectedTitle"
                                                            ) | translate
                                                        }}
                                                        )
                                                    </div>
                                                    <div
                                                        class="wk-cf__popover__actions-link wk-cf__popover__actions-selection-clear"
                                                        (click)="onClearAllGroups('group2')"
                                                    >
                                                        {{ "FiltersSidebar.Options.MultiSelect.ClearTitle" | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                            <kendo-textbox
                                                class="wk-cf__popover__search"
                                                placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
                                                (valueChange)="onSearchChange($event, 'group2')"
                                            >
                                                <button kendoButton fillMode="flat"></button>
                                            </kendo-textbox>
                                            <div class="wk-cf__popover__list">
                                                @for (item of settingPagedItems_Group2; track item.id) {
                                                    <checkbox-field-pds3
                                                        size="extra-small"
                                                        labelFor="group2-{{ item.id }}"
                                                        [label]="item.value | wkTranslate"
                                                    >
                                                        <input
                                                            (change)="onGroup2FilterChange(item)"
                                                            type="checkbox"
                                                            [checked]="isGroupItemSelected(item.id, group2Options)"
                                                            attr.id="group2-{{ item.id }}"
                                                        />
                                                    </checkbox-field-pds3>
                                                }
                                            </div>
                                            @if (maxSettingPageSize_Group2 > 1) {
                                                <wk-pagination-component
                                                    #pagination
                                                    [collectionSize]="totalItemsCount_Group2"
                                                    [pageSize]="settingPageSize_Group2"
                                                    [firstLastButtons]="false"
                                                    [currentPage]="settingPageNumber_Group2"
                                                    (pageChange)="onSettingPageChange($event, 'group2')"
                                                />
                                            }
                                        </div>
                                    </ng-template>
                                </kendo-popover>
                            </div>
                            <!------------------------------------------------------------------->
                        </th>
                    }
                    <th class="wk-sdm__table-header-cell wk-sdm__table-header-cell--roles">
                        <!------------------------------------------------------------------->
                        <!-- Need to be moved to the component + Replaced by the component -->
                        <div class="wk-cf">
                            <div
                                class="wk-cf__container"
                                kendoPopoverContainer
                                filter=".wk-cf__trigger--roles"
                                #rolesPopoverTrigger="kendoPopoverContainer"
                            >
                                <div>{{ "Settings.Role" | translate }}</div>
                                <button
                                    class="wk-cf__trigger wk-cf__trigger--roles"
                                    [class.wk-cf__trigger--funnel-filled]="rolesOptions && rolesOptions.selectedValues.length > 0"
                                    [class.wk-cf__trigger--funnel]="!rolesOptions || rolesOptions.selectedValues.length == 0"
                                    kendoButton
                                ></button>
                            </div>
                            <kendo-popover #RolesPopover position="bottom" (shown)="onShow_Roles()">
                                <ng-template kendoPopoverBodyTemplate>
                                    <div class="wk-cf__popover">
                                        <div class="wk-cf__popover__header">
                                            <div class="wk-cf__popover__actions">
                                                <div
                                                    class="wk-cf__popover__actions-link wk-cf__popover__actions-select-all"
                                                    (click)="onSelectAllRoles()"
                                                >
                                                    {{ "Settings.SelectAll" | translate }}
                                                </div>
                                                <div class="wk-rolesOptions-selection-count">
                                                    ( {{ rolesOptions.selectedValues.length }}
                                                    {{
                                                        (this.rolesOptions.selectedValues.length > 1
                                                            ? "AllView.MultipleCardSelectedTitle"
                                                            : "AllView.SingleCardSelectedTitle"
                                                        ) | translate
                                                    }}
                                                    )
                                                </div>
                                                <div
                                                    class="wk-cf__popover__actions-link wk-cf__popover__actions-selection-clear"
                                                    (click)="onClearAllRoles()"
                                                >
                                                    {{ "FiltersSidebar.Options.MultiSelect.ClearTitle" | translate }}
                                                </div>
                                            </div>
                                        </div>
                                        <kendo-textbox
                                            class="wk-cf__popover__search"
                                            placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
                                            (valueChange)="onSearchChange_Roles($event)"
                                        >
                                            <button kendoButton fillMode="flat"></button>
                                        </kendo-textbox>
                                        <div class="wk-cf__popover__list">
                                            @for (item of settingPagedItems_Roles; track item.id) {
                                                <checkbox-field-pds3
                                                    size="extra-small"
                                                    labelFor="role-{{ item.id }}"
                                                    [label]="item.value.Description | wkTranslate"
                                                >
                                                    <input
                                                        (change)="onRolesFilterValueChange(item, $event.target.checked)"
                                                        type="checkbox"
                                                        [checked]="isRoleItemSelected(item.id)"
                                                        attr.id="role-{{ item.id }}"
                                                    />
                                                </checkbox-field-pds3>
                                            }
                                        </div>
                                        @if (maxSettingPageSize_Roles > 1) {
                                            <wk-pagination-component
                                                #pagination
                                                [collectionSize]="totalItemsCount_Roles"
                                                [pageSize]="settingPageSize_Roles"
                                                [firstLastButtons]="false"
                                                [currentPage]="settingPageNumber_Roles"
                                                (pageChange)="onSettingPageChange_Roles($event)"
                                            />
                                        }
                                    </div>
                                </ng-template>
                            </kendo-popover>
                        </div>
                        <!------------------------------------------------------------------->
                    </th>
                    <th class="wk-sdm__table-header-cell wk-sdm__table-header-cell--access">
                        <!------------------------------------------------------------------->
                        <!-- Need to be moved to the component + Replaced by the component -->
                        <div class="wk-cf">
                            <div
                                class="wk-cf__container"
                                kendoPopoverContainer
                                filter=".wk-cf__trigger--access"
                                #accessPopoverTrigger="kendoPopoverContainer"
                            >
                                <div>{{ "Settings.Access" | translate }}</div>
                                <button
                                    class="wk-cf__trigger wk-cf__trigger--access"
                                    [class.wk-cf__trigger--funnel-filled]="accessOptions && accessOptions.selectedValues.length > 0"
                                    [class.wk-cf__trigger--funnel]="!accessOptions || accessOptions.selectedValues.length == 0"
                                    kendoButton
                                ></button>
                            </div>
                            <kendo-popover #AccessPopover position="bottom" (shown)="onShow_Access()">
                                <ng-template kendoPopoverBodyTemplate>
                                    <div class="wk-cf__popover">
                                        <div class="wk-cf__popover__header">
                                            <div class="wk-cf__popover__actions">
                                                <div
                                                    class="wk-cf__popover__actions-link wk-cf__popover__actions-select-all"
                                                    (click)="onSelectAllAccess()"
                                                >
                                                    {{ "Settings.SelectAll" | translate }}
                                                </div>
                                                <div class="wk-cf__popover__actions-selection-count">
                                                    ( {{ accessOptions.selectedValues.length }}
                                                    {{
                                                        (this.accessOptions.selectedValues.length > 1
                                                            ? "AllView.MultipleCardSelectedTitle"
                                                            : "AllView.SingleCardSelectedTitle"
                                                        ) | translate
                                                    }}
                                                    )
                                                </div>
                                                <div
                                                    class="wk-cf__popover__actions-link wk-cf__popover__actions-selection-clear"
                                                    (click)="onClearAllAccess()"
                                                >
                                                    {{ "FiltersSidebar.Options.MultiSelect.ClearTitle" | translate }}
                                                </div>
                                            </div>
                                        </div>
                                        <kendo-textbox
                                            class="wk-cf__popover__search"
                                            placeholder="{{ 'SearchBar.PlaceHolder' | translate }}"
                                            (valueChange)="onSearchChange_Access($event)"
                                        >
                                            <button kendoButton fillMode="flat"></button>
                                        </kendo-textbox>
                                        <div class="wk-cf__popover__list">
                                            @for (item of settingPagedItems_Access; track item.id) {
                                                <checkbox-field-pds3
                                                    size="extra-small"
                                                    labelFor="access-{{ item.id }}"
                                                    [label]="item.value | wkTranslate"
                                                >
                                                    <input
                                                        (change)="onAccessFilterValueChange(item, $event.target.checked)"
                                                        type="checkbox"
                                                        [checked]="isAccessItemSelected(item.id)"
                                                        attr.id="access-{{ item.id }}"
                                                    />
                                                </checkbox-field-pds3>
                                            }
                                        </div>
                                        @if (maxSettingPageSize_Access > 1) {
                                            <wk-pagination-component
                                                #pagination
                                                [collectionSize]="totalItemsCount_Access"
                                                [pageSize]="settingPageSize_Access"
                                                [firstLastButtons]="false"
                                                [currentPage]="settingPageNumber_Access"
                                                (pageChange)="onSettingPageChange_Access($event)"
                                            />
                                        }
                                    </div>
                                </ng-template>
                            </kendo-popover>
                        </div>
                        <!------------------------------------------------------------------->
                    </th>
                </tr>
                @for (user of model | paginate: { itemsPerPage: pageSize(), currentPage: page }; track user) {
                    <tr class="wk-sdm__table-row">
                        <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--select">
                            <checkbox-field-pds3>
                                <input type="checkbox" [(ngModel)]="user.Selected" (change)="updateSelectedCount()" />
                            </checkbox-field-pds3>
                        </td>
                        <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--first-name">{{ user.FirstName }}</td>
                        <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--last-name">{{ user.LastName }}</td>
                        @if (group1Enabled && getGroup1UsersEnabled() == true) {
                            <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--group1">
                                {{ getGroup1OptionCaption(user.GroupFilteringId1) }}
                            </td>
                        }
                        @if (group2Enabled && getGroup2UsersEnabled() == true) {
                            <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--group2">
                                {{ getGroup2OptionCaption(user.GroupFilteringId2) }}
                            </td>
                        }
                        <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--roles wk-sdm__table-row-cell--ellipsed">{{ user.RolesJoined }}</td>
                        <td class="wk-sdm__table-row-cell wk-sdm__table-row-cell--access">
                            <select-field-pds3 size="medium" label="">
                                <select [(ngModel)]="user.HasAccess" (ngModelChange)="isFormChanged = true">
                                    <option [ngValue]="true" [selected]="user.HasAccess">
                                        {{ "General.Yes" | translate }}
                                    </option>
                                    <option [ngValue]="false" [selected]="!user.HasAccess">
                                        {{ "General.No" | translate }}
                                    </option>
                                </select>
                            </select-field-pds3>
                        </td>
                    </tr>
                }
            </table>
        </div>
        <div class="wk-sdm__pagination">
            <pagination-controls
                previousLabel="{{ 'General.Pagination.Previous' | translate }}"
                nextLabel="{{ 'General.Pagination.Next' | translate }}"
                (pageChange)="page = $event; updateSelectedCount()"
            />
        </div>
    </div>
</div>

<div class="wk-sdm__actions">
    <button [disabled]="selectedCount == 0" class="btn-action wk-sdm__actions--change-access" (click)="onChangeAccess()">
        {{ "Settings.btnChangeAccess" | translate }}
    </button>
    <button class="btn-primary wk-sdm__actions--save" [disabled]="!isFormChanged" (click)="onSave()">
        {{ "Settings.Save" | translate }}
        @if (isSaving) {
            <app-loader [isOverlay]="false" size="button" />
        }
    </button>
    <button class="btn-secondary wk-sdm__actions--cancel" (click)="onCancelChanges()">{{ "General.Close" | translate }}</button>
</div>
<div kendoDialogContainer></div>
